import { H5 } from 'platform-components/common';
import { TEXT_WEIGHT } from 'platform-components/constants';
import React from 'react';

import './spec-course-lesson-view__stub-title.scss';

interface Props {
    id: string;
}

export const SpecCourseLessonViewStubTitle = React.memo(({ id }: Props) => {
    return (
        <div className="spec-course-lesson-view__stub-title">
            <H5 id={id} weight={TEXT_WEIGHT.M} />
        </div>
    );
});
